export default {
  en: {
    // Legacy camelCase keys
    overtime: 'Overtime',
    schedule: 'Schedule',
    punch: 'Punch',
    timeAndAttendance: 'Time and Attendance',
    timeAndAttendanceAnalysis: 'Time and Attendance Analysis',
    crewSwing: 'Crew/Swing',
    laborSchedule: 'Labor Schedule',

    // All Hours
    'by-date': 'By Date',
    'sum-all-dates': 'Sum all Dates',
    'all-hours': 'All Hours',
    'fixed-sch-hrs': 'Fixed Sch Hrs',
    'scheduled-hours-for-schedule-symbols':
      "Scheduled hours for Schedule symbols that are 'fixed' (not dependent on sales volume)",
    'total-need-hrs': 'Total Need Hrs',
    'total-needed-hours':
      'Total Needed Hours - Variable Hours Needed plus Floor Hours Needed + Fixed Hours Scheduled',
    'act-gc-vs-proj': 'Act GC vs Proj',
    'actual-gc-minus-gc':
      'Actual GC minus GC that were projected in the scheduling software',
    'act-hrs': 'Act Hrs',
    'actual-hours-used':
      'Actual Hours used - Punched Hours plus Scheduled Salaried Hours',
    'act-hrs-vs-need': 'Act Hrs vs Need',
    'actual-hours-used-compared-to-hours-needed':
      'Actual hours used compared to hours needed (Needed Hours = Variable Needed + Fixed Sch Hrs + Flr Need Hrs)',
    'indicates-that-actual-hours-are-greater':
      'indicates that Actual Hours are greater than Needed Hours by 0.5 hours or more',
    'indicates-that-actual-hours-are-less':
      'indicates that Actual Hours are less than Needed Hours by 0.5 hours or more',
    'act-hrs-vs-sch': 'Act Hrs vs Sch',
    'actual-hours-used-compared-to-hours-that-were-scheduled':
      'Actual Hours used compared to Hours that were scheduled',
    'indicates-that-actual-hours-are-greater-than-scheduled-hours':
      'indicates that Actual Hours are greater than Scheduled Hours by 0.5 hours or more',
    'indicates-that-actual-hours-are-less-than-scheduled-hours':
      'indicates that Actual Hours are less than Scheduled Hours by 0.5 hours or more',
    'act-punch-hrs': 'Act Punch Hrs',
    'actual-hours-punched-on-the-time-clock':
      'Actual Hours punched on the time clock',
    'actual-gc': 'Actual GC',
    'actual-gc-recorded-by-the-pos': 'Actual GC recorded by the POS',
    'flr-need-hrs': 'Flr Need Hrs',
    'manager-hours-needed-to-run-the-floor':
      'Manager Hours needed to run the floor',
    'flr-sch-hrs': 'Flr Sch Hrs',
    'manager-hours-scheduled-to-run-the-floor':
      'Manager Hours Scheduled to run the floor',
    'projected-gc': 'Projected GC',
    'salaried-manager-hrs': 'Salaried Manager Hrs',
    'since-salaried-managers-do-not-punch-the-clock':
      'Since Salaried managers do not punch the clock, Scheduled Salaried Manager hours are used (it is assumed that all scheduled salaried hours get worked)',
    'sch-hrs': 'Sch Hrs',
    'scheduled-hours': 'Scheduled Hours',
    'sched-vs-guide': 'Sched vs Guide',
    'scheduled-hours-compared-to-projected-need':
      'Scheduled Hours compared to Projected Need',
    'indicates-that-scheduled-hours-are-greater-than-projected-need-by-0-5-hours-or-more':
      'indicates that Scheduled Hours are greater than Projected Need by 0.5 hours or more',
    'indicates-that-scheduled-hours-are-less-than-projected-need-by-0-5-hours-or-more':
      'indicates that Scheduled Hours are less than Projected Need by 0.5 hours or more',
    'proj-eff': 'Proj Eff',
    'was-the-number-of-hours-where-actual-gc':
      'Was the number of hours where Actual GC was within 10 of Projected GC, divided by total hours the restaurant was open (Yes/No)',
    'vlh-sched-hrs': 'VLH Sched Hrs',
    'sum-of-all-scheduled-variable-labor-hours':
      'Sum of all Scheduled Variable Labor Hours',
    'end-time': 'End Time',

    // Fixed Hours vs Guide
    'fixed-hours-schedule-vs-guide': 'Fixed Hours Schedule vs Guide',
    'fixed-guide': 'Fixed Guide',
    'hours-in-the-fixed-hours-guide':
      'Hours in the Fixed Hours guide (also called a contract) for a given scheduling symbol',
    'sched-vs-contract': 'Sched vs Contract',
    'sched-time-minus-fixed-guide': 'Sched Time minus Fixed Guide',
    'sched-time': 'Sched Time',
    'hours-scheduled-for-a-given-fixed-symbol':
      'Hours scheduled for a given fixed symbol',
    'symbol-description': 'Symbol Description',
    'extended-description-of-labor-scheduling-symbols':
      'Extended description of Labor Scheduling Symbols',
    symbol: 'Symbol',
    'one-or-two-letter-scheduling-symbols':
      'One or Two-letter scheduling symbols',

    // Labor Analysis Summary
    'labor-schedule': 'Labor Schedule',
    'schedule-type': 'Schedule Type',
    description: 'Description',
    'analysis-summary': 'Analysis Summary',
    'symbol-over-unders': 'Symbol Over/Unders',
    'planned-hours': 'Planned Hours',
    hours: '+/- Hours',
    'symbol-over-under-chart': 'Symbol Over/Under Chart',

    // Labor Schedules
    'labor-schedules': 'Labor Schedules',
    'labor-schedules-stats': 'Labor Schedules Stats',
    hour: 'Hour',

    // Labor Analysis
    'labor-analysis': 'Labor Analysis',
    'fixed-sched-flr-need': 'Fixed Sched + Flr Need',
    'fixed-sched-flr-sched': 'Fixed Sched + Flr Sched',
    'fixed-contract-flr-needed': 'Fixed Contract + Flr Needed',

    // Labor Statistics
    'labor-statistics': 'Labor Statistics',
    'we-have-adjusted-this-report':
      'We have adjusted this report to be aligned with your DAR reporting.',
    'fields-that-are-not-available':
      'Fields that are not available at the quarter hour level have been removed for data clarity.',
    'you-will-still-be-able': 'You will still be able to find these on the',
    'labor-analysis-report': 'Labor Analysis report',
    labor: 'Labor',
    sales: 'Sales',
    projected: 'Projected',
    'labor-statistics-analysis': 'Labor Statistics Analysis',

    // Schedule Variance
    'schedule-variance': 'Schedule Variance',
    'location-summary': 'Location Summary',
    'location-detail': 'Location Detail',

    // VLH Over/Under
    'vlh-over-under': 'VLH Over/Under',
    'projected-orders': 'Projected Orders',
    'projected-labor': 'Projected Labor',
    'over-under': 'Over/Under',
    // laborSchedulesChart
    chart: 'Chart',
    'sort-by-shift-start': 'Sort by Shift Start',
    'sort-by-shift-type': 'Sort by Shift Type',
    'chart-legend': 'Chart Legend',
    color: 'Color',
    close: 'Close',
    floor: 'Floor',
    'floor-guest-services': 'Floor Guest Services',
    'floor-production': 'Floor Production',
    'beverage-specialist': 'Beverage Specialist',
    'grill-regular-menu': 'Grill Regular Menu',
    'grill-breakfast-menu': 'Grill Breakfast Menu',
    'french-fry': 'French Fry',
    hashbrown: 'Hashbrown',
    window: 'Window',
    'administration/cash': 'Administration/Cash',
    'birthday-parties': 'Birthday Parties',
    closing: 'Closing',
    'food-safety': 'Food Safety',
    hiring: 'Hiring',
    'individual-development': 'Individual Development',
    lobby: 'Lobby',
    maintenance: 'Maintenance',
    'manager-meeting': 'Manager Meeting',
    opening: 'Opening',
    'planned-maintenance': 'Planned Maintenance',
    'pre-shift': 'Pre-Shift',
    schedules: 'Schedules',
    stat: 'Stat',
    'support/prep': 'Support/Prep',
    training: 'Training',
    transition: 'Transition',
    'truck-delivery': 'Truck Delivery',
    vat: 'Vat',
    'walk-thru': 'Walk Thru',
    'operations-technology-person': 'OTP (Operations Technology Person)',
    'guest-experience-lead': 'Guest Experience Lead',
    'general-manager': 'General Manager',
    'meal-break-unpaid': 'Meal Break (Unpaid)',
    'meal-break-paid': 'Meal Break (Paid)',
    'rest-break-paid': 'Rest Break (Paid)',
    'lactation-break-unpaid': 'Lactation Break (Unpaid)',
    'lactation-break-paid': 'Lactation Break (Paid)',
    name: 'Name',
    'shift-start': 'Shift Start',
    'shift-end': 'Shift End',

    // Employee Roster & Time Punches reports
    'employee-roster': 'Employee Roster',
    'time-punches': 'Time Punches',
    'employee-punches': 'Employee Punches',
    'date-s': 'Date(s)',
    'location-type': 'Location Type',
    'employment-status': 'Employment Status',
    employees: 'Employees',
    corporate: 'Corporate',
    franchise: 'Franchise',
    active: 'Active',
    terminated: 'Terminated',
  },
  es: {
    overtime: 'Tiempo Extra',
    schedule: 'Horario',
    punch: 'Registro',
    timeAndAttendance: 'Tiempo y Asistencia',
    timeAndAttendanceAnalysis: 'Análisis de Tiempo y Asistencia',
    crewSwing: 'Tripulación/Rotación',
    laborSchedule: 'Horario Laboral',

    'by-date': 'Por Fecha',
    'sum-all-dates': 'Sumar Todas las Fechas',
    'all-hours': 'Todas las Horas',
    'fixed-sch-hrs': 'Horas Programadas Fijas',
    'scheduled-hours-for-schedule-symbols':
      "Horas programadas para los simbolos de programacion que son 'fijos' (no dependen del volumen de ventas)",
    'total-need-hrs': 'Total Necesidad Hrs',
    'total-needed-hours':
      'Horas Totales Necesarias - Horas Variables Necesarias mas Horas Necesarias de Piso + Horas Programadas Fijas',
    'act-gc-vs-proj': 'GC Actual vs Proyectadas',
    'actual-gc-minus-gc':
      'GC Real menos GC que se proyectaron en el software de programacion',
    'act-hrs': 'Horas Actuales',
    'actual-hours-used':
      'Horas reales utilizadas - Horas marcadas mas horas programadas de gerente asalariado',
    'act-hrs-vs-need': 'Horas Actuales vs Necesidad',
    'actual-hours-used-compared-to-hours-needed':
      'Horas reales utilizadas en comparacion con las horas necesarias (Horas necesarias = Necesidad variable + Horas programadas fijas + Horas necesarias de piso)',
    'indicates-that-actual-hours-are-greater':
      'indica que las horas reales son mayores que las horas necesarias en 0.5 horas o mas',
    'indicates-that-actual-hours-are-less':
      'indica que las horas reales son menores que las horas necesarias en 0.5 horas o mas',
    'act-hrs-vs-sch': 'Horas Actuales vs Programadas',
    'actual-hours-used-compared-to-hours-that-were-scheduled':
      'Horas reales utilizadas en comparacion con las horas que se programaron',
    'indicates-that-actual-hours-are-greater-than-scheduled-hours':
      'indica que las horas reales son mayores que las horas programadas en 0.5 horas o mas',
    'indicates-that-actual-hours-are-less-than-scheduled-hours':
      'Indica que las horas reales son menores que las horas programadas en 0,5 horas o mas',
    'act-punch-hrs': 'Horas Fichadas',
    'actual-hours-punched-on-the-time-clock':
      'Horas reales marcadas en el reloj',
    'actual-gc': 'GC Real',
    'actual-gc-recorded-by-the-pos': 'GC Real registrado por el POS',
    'flr-need-hrs': 'Hrs Necesarias de Piso',
    'manager-hours-needed-to-run-the-floor':
      'Horas de gerente necesarias para ejecutar el piso',
    'flr-sch-hrs': 'Horas Programadas de Piso',
    'manager-hours-scheduled-to-run-the-floor':
      'Horas de gerente programadas para ejecutar el piso',
    'projected-gc': 'GC Proyectado',
    'salaried-manager-hrs': 'Horas de Gerente Asalariado',
    'since-salaried-managers-do-not-punch-the-clock':
      'Dado que los gerentes asalariados no marcan el reloj, se utilizan las horas programadas de gerente asalariado (se asume que todas las horas programadas de gerente asalariado se trabajan)',
    'sch-hrs': 'Horas Programadas',
    'scheduled-hours': 'Horas Programadas',
    'sched-vs-guide': 'Programa vs Guia',
    'scheduled-hours-compared-to-projected-need':
      'Horas programadas en comparacion con la necesidad proyectada',
    'indicates-that-scheduled-hours-are-greater-than-projected-need-by-0-5-hours-or-more':
      'indica que las horas programadas son mayores que la necesidad proyectada en 0.5 horas o mas',
    'indicates-that-scheduled-hours-are-less-than-projected-need-by-0-5-hours-or-more':
      'indica que las horas programadas son menores que la necesidad proyectada en 0.5 horas o mas',
    'proj-eff': 'Eficiencia Proyectada',
    'was-the-number-of-hours-where-actual-gc':
      'Fue el numero de horas en las que el GC real estuvo dentro de 10 del GC proyectado, dividido por el total de horas que el restaurante estuvo abierto (Si/No)',
    'vlh-sched-hrs': 'VLH Hora Programadas',
    'sum-of-all-scheduled-variable-labor-hours':
      'Suma de todas las horas de trabajo variable programadas',
    'end-time': 'Hora de Finalizacion',

    'fixed-hours-schedule-vs-guide': 'Horas Fijas Programadas vs Guia',
    'fixed-guide': 'Guia Fija',
    'hours-in-the-fixed-hours-guide':
      'Horas en la guia de horas fijas (tambien llamada contrato) para un simbolo de programacion dado',
    'sched-vs-contract': 'Programado vs contrato',
    'sched-time-minus-fixed-guide': 'Tiempo Programado menos Guia Fija',
    'sched-time': 'Tiempo Programado',
    'hours-scheduled-for-a-given-fixed-symbol':
      'Horas programadas para un simbolo fijo dado',
    'symbol-description': 'Descripcion del Simbolo',
    'extended-description-of-labor-scheduling-symbols':
      'Descripcion extendida de los simbolos de programacion de mano de obra',
    symbol: 'Simbolo',
    'one-or-two-letter-scheduling-symbols':
      'Simbolos de programacion de una o dos letras',

    'labor-schedule': 'Horario de Trabajo',
    'schedule-type': 'Tipo de Horario',
    description: 'Descripcion',
    'analysis-summary': 'Resumen del Analisis',
    'symbol-over-unders': 'Simbolo de Mas/Menos',
    'planned-hours': 'Horas Planificadas',
    hours: '+/- Horas',
    'symbol-over-under-chart': 'Grafico de Simbolos de Sobrantes y Faltantes',

    'labor-schedules': 'Horarios de Trabajo',
    'labor-schedules-stats': 'Estadisticas de Horarios de Trabajo',
    hour: 'Hora',

    'labor-analysis': 'Analisis de Mano de Obra',
    'fixed-sched-flr-need': 'Programacion Fija + Necesidad de Piso',
    'fixed-sched-flr-sched': 'Programacion Fija + Programacion de Piso',
    'fixed-contract-flr-needed': 'Contrato Fijo + Necesidad de Piso',

    'labor-statistics': 'Estadisticas de Mano de Obra',
    'we-have-adjusted-this-report':
      'Hemos ajustado este informe para que se alinee con su informe DAR.',
    'fields-that-are-not-available':
      'Los campos que no estan disponibles a nivel de cuarto de hora se han eliminado para mayor claridad de los datos.',
    'you-will-still-be-able': 'Aun podra encontrarlos en el',
    'labor-analysis-report': 'Informe de Analisis de Mano de Obra',
    labor: 'Mano de Obra',
    sales: 'Ventas',
    projected: 'Proyectado',
    'labor-statistics-analysis': 'Analisis de Estadisticas de Mano de Obra',

    'schedule-variance': 'Variacion de Horario',
    'location-summary': 'Resumen de Ubicacion',
    'location-detail': 'Detalle de Ubicacion',

    'vlh-over-under': 'VLH Mas/Menos',
    'projected-orders': 'Pedidos Proyectados',
    'projected-labor': 'Labor Proyectado',
    'over-under': 'Mas/Menos',
    // laborSchedulesChart
    chart: 'Gráfico',
    'sort-by-shift-start': 'Ordenar por Inicio de Turno',
    'sort-by-shift-type': 'Ordenar por Tipo de Turno',
    'chart-legend': 'Leyenda del Gráfico',
    color: 'Color',
    close: 'Cerrar',
    floor: 'Piso',
    'floor-guest-services': 'Piso de Servicios al Huésped',
    'floor-production': 'Piso de Producción',
    'beverage-specialist': 'Especialista en Bebidas',
    'grill-regular-menu': 'Parrilla Menú Regular',
    'grill-breakfast-menu': 'Parrilla Menú de Desayuno',
    'french-fry': 'Papas Fritas',
    hashbrown: 'Papas Ralladas',
    window: 'Ventana',
    'administration/cash': 'Administración/Caja',
    'birthday-parties': 'Fiestas de Cumpleaños',
    closing: 'Cierre',
    'food-safety': 'Seguridad Alimentaria',
    hiring: 'Contratación',
    'individual-development': 'Desarrollo Individual',
    lobby: 'Vestíbulo',
    maintenance: 'Mantenimiento',
    'manager-meeting': 'Reunión de Gerentes',
    opening: 'Apertura',
    'planned-maintenance': 'Mantenimiento Programado',
    'pre-shift': 'Pre-Turno',
    schedules: 'Horarios',
    stat: 'Estadística',
    'support/prep': 'Apoyo/Preparación',
    training: 'Entrenamiento',
    transition: 'Transición',
    'truck-delivery': 'Entrega de Camión',
    vat: 'Tina',
    'walk-thru': 'Inspección',
    'operations-technology-person':
      'PTO (Persona de Tecnología de Operaciones)',
    'guest-experience-lead': 'Líder de Experiencia del Cliente',
    'general-manager': 'Gerente General',
    'meal-break-unpaid': 'Descanso de Comida (No Pagado)',
    'meal-break-paid': 'Descanso de Comida (Pagado)',
    'rest-break-paid': 'Descanso (Pagado)',
    'lactation-break-unpaid': 'Descanso de Lactancia (No Pagado)',
    'lactation-break-paid': 'Descanso de Lactancia (Pagado)',
    name: 'Nombre',
    'shift-start': 'Inicio de Turno',
    'shift-end': 'Fin de Turno',

    // Employee Roster & Time Punches reports
    'employee-roster': 'Lista de Empleados',
    'time-punches': 'Registros de Tiempo',
    'employee-punches': 'Registros de Empleados',
    'date-s': 'Fecha(s)',
    'location-type': 'Tipo de Ubicación',
    'employment-status': 'Estado de Empleo',
    employees: 'Empleados',
    corporate: 'Corporativo',
    franchise: 'Franquicia',
    active: 'Activo',
    terminated: 'Terminado',
  },
  fr: {
    // Legacy camelCase keys
    overtime: 'Heures supplémentaires',
    schedule: 'Planning',
    punch: 'Pointage',
    timeAndAttendance: 'Temps et présence',
    timeAndAttendanceAnalysis: 'Analyse des temps et présences',
    crewSwing: 'Équipiers / polyvalents',
    laborSchedule: 'Planning du personnel',

    // All Hours
    'by-date': 'Par date',
    'sum-all-dates': 'Cumuler toutes les dates',
    'all-hours': 'Toutes les heures',
    'fixed-sch-hrs': 'H. fixes planifiées',
    'scheduled-hours-for-schedule-symbols':
      'Heures planifiées pour les symboles de planning « fixes » (indépendants du volume de ventes)',
    'total-need-hrs': 'Total h. requises',
    'total-needed-hours':
      'Total des heures requises - Heures variables requises plus heures d’encadrement requises + heures fixes planifiées',
    'act-gc-vs-proj': 'GC réel vs prév.',
    'actual-gc-minus-gc':
      'GC réel moins le GC prévu dans le logiciel de planification',
    'act-hrs': 'H. réelles',
    'actual-hours-used':
      'Heures réellement utilisées - Heures pointées plus heures planifiées des salariés',
    'act-hrs-vs-need': 'H. réelles vs requises',
    'actual-hours-used-compared-to-hours-needed':
      'Heures réellement utilisées comparées aux heures requises (Heures requises = Variables requises + H. fixes planifiées + H. encadrement requises)',
    'indicates-that-actual-hours-are-greater':
      'indique que les heures réelles dépassent les heures requises de 0,5 heure ou plus',
    'indicates-that-actual-hours-are-less':
      'indique que les heures réelles sont inférieures aux heures requises de 0,5 heure ou plus',
    'act-hrs-vs-sch': 'H. réelles vs planifiées',
    'actual-hours-used-compared-to-hours-that-were-scheduled':
      'Heures réellement utilisées comparées aux heures planifiées',
    'indicates-that-actual-hours-are-greater-than-scheduled-hours':
      'indique que les heures réelles dépassent les heures planifiées de 0,5 heure ou plus',
    'indicates-that-actual-hours-are-less-than-scheduled-hours':
      'indique que les heures réelles sont inférieures aux heures planifiées de 0,5 heure ou plus',
    'act-punch-hrs': 'H. pointées réelles',
    'actual-hours-punched-on-the-time-clock':
      'Heures réellement pointées sur la pointeuse',
    'actual-gc': 'GC réel',
    'actual-gc-recorded-by-the-pos': 'GC réel enregistré par la caisse',
    'flr-need-hrs': 'H. encadrement requises',
    'manager-hours-needed-to-run-the-floor':
      'Heures de manager nécessaires pour piloter la salle',
    'flr-sch-hrs': 'H. encadrement planifiées',
    'manager-hours-scheduled-to-run-the-floor':
      'Heures de manager planifiées pour piloter la salle',
    'projected-gc': 'GC prévu',
    'salaried-manager-hrs': 'H. managers salariés',
    'since-salaried-managers-do-not-punch-the-clock':
      'Les managers salariés ne pointant pas, ce sont les heures planifiées des managers salariés qui sont utilisées (on considère que toutes les heures planifiées des salariés sont travaillées)',
    'sch-hrs': 'H. planifiées',
    'scheduled-hours': 'Heures planifiées',
    'sched-vs-guide': 'Planifié vs guide',
    'scheduled-hours-compared-to-projected-need':
      'Heures planifiées comparées au besoin prévu',
    'indicates-that-scheduled-hours-are-greater-than-projected-need-by-0-5-hours-or-more':
      'indique que les heures planifiées dépassent le besoin prévu de 0,5 heure ou plus',
    'indicates-that-scheduled-hours-are-less-than-projected-need-by-0-5-hours-or-more':
      'indique que les heures planifiées sont inférieures au besoin prévu de 0,5 heure ou plus',
    'proj-eff': 'Efficacité prév.',
    'was-the-number-of-hours-where-actual-gc':
      'Nombre d’heures où le GC réel se situait à moins de 10 du GC prévu, divisé par le nombre total d’heures d’ouverture du restaurant (Oui/Non)',
    'vlh-sched-hrs': 'H. planifiées VLH',
    'sum-of-all-scheduled-variable-labor-hours':
      'Somme de toutes les heures de main-d’œuvre variable planifiées',
    'end-time': 'Heure de fin',

    // Fixed Hours vs Guide
    'fixed-hours-schedule-vs-guide': 'Heures fixes : planning vs guide',
    'fixed-guide': 'Guide heures fixes',
    'hours-in-the-fixed-hours-guide':
      'Heures inscrites au guide des heures fixes (également appelé contrat) pour un symbole de planning donné',
    'sched-vs-contract': 'Planifié vs contrat',
    'sched-time-minus-fixed-guide': 'Temps planifié moins guide heures fixes',
    'sched-time': 'Temps planifié',
    'hours-scheduled-for-a-given-fixed-symbol':
      'Heures planifiées pour un symbole fixe donné',
    'symbol-description': 'Description du symbole',
    'extended-description-of-labor-scheduling-symbols':
      'Description détaillée des symboles de planification du personnel',
    symbol: 'Symbole',
    'one-or-two-letter-scheduling-symbols':
      'Symboles de planification à une ou deux lettres',

    // Labor Analysis Summary
    'labor-schedule': 'Planning du personnel',
    'schedule-type': 'Type de planning',
    description: 'Description',
    'analysis-summary': 'Synthèse de l’analyse',
    'symbol-over-unders': 'Écarts par symbole',
    'planned-hours': 'Heures planifiées',
    hours: '+/- heures',
    'symbol-over-under-chart': 'Graphique des écarts par symbole',

    // Labor Schedules
    'labor-schedules': 'Plannings du personnel',
    'labor-schedules-stats': 'Statistiques des plannings',
    hour: 'Heure',

    // Labor Analysis
    'labor-analysis': 'Analyse de la main-d’œuvre',
    'fixed-sched-flr-need': 'Fixe planifié + encadrement requis',
    'fixed-sched-flr-sched': 'Fixe planifié + encadrement planifié',
    'fixed-contract-flr-needed': 'Contrat fixe + encadrement requis',

    // Labor Statistics
    'labor-statistics': 'Statistiques de main-d’œuvre',
    'we-have-adjusted-this-report':
      'Nous avons ajusté ce rapport pour l’aligner sur votre reporting DAR.',
    'fields-that-are-not-available':
      'Les champs non disponibles au niveau du quart d’heure ont été retirés pour plus de clarté.',
    'you-will-still-be-able': 'Vous pourrez toujours les retrouver dans le',
    'labor-analysis-report': 'rapport d’analyse de la main-d’œuvre',
    labor: 'Main-d’œuvre',
    sales: 'Ventes',
    projected: 'Prévu',
    'labor-statistics-analysis': 'Analyse des statistiques de main-d’œuvre',

    // Schedule Variance
    'schedule-variance': 'Écart de planning',
    'location-summary': 'Synthèse par site',
    'location-detail': 'Détail par site',

    // VLH Over/Under
    'vlh-over-under': 'Écart VLH',
    'projected-orders': 'Commandes prévues',
    'projected-labor': 'Main-d’œuvre prévue',
    'over-under': 'Écart',
    // laborSchedulesChart
    chart: 'Graphique',
    'sort-by-shift-start': 'Trier par début de poste',
    'sort-by-shift-type': 'Trier par type de poste',
    'chart-legend': 'Légende du graphique',
    color: 'Couleur',
    close: 'Fermer',
    floor: 'Salle',
    'floor-guest-services': 'Salle - service client',
    'floor-production': 'Salle - production',
    'beverage-specialist': 'Spécialiste boissons',
    'grill-regular-menu': 'Grill - menu classique',
    'grill-breakfast-menu': 'Grill - menu petit-déjeuner',
    'french-fry': 'Frites',
    hashbrown: 'Galette de pomme de terre',
    window: 'Guichet',
    'administration/cash': 'Administration / caisse',
    'birthday-parties': 'Anniversaires',
    closing: 'Fermeture',
    'food-safety': 'Sécurité alimentaire',
    hiring: 'Recrutement',
    'individual-development': 'Développement individuel',
    lobby: 'Salle',
    maintenance: 'Maintenance',
    'manager-meeting': 'Réunion managers',
    opening: 'Ouverture',
    'planned-maintenance': 'Maintenance planifiée',
    'pre-shift': 'Avant-poste',
    schedules: 'Plannings',
    stat: 'Statistiques',
    'support/prep': 'Support / préparation',
    training: 'Formation',
    transition: 'Transition',
    'truck-delivery': 'Livraison camion',
    vat: 'Bac de friture',
    'walk-thru': 'Tour de restaurant',
    'operations-technology-person': 'OTP (référent technologie opérations)',
    'guest-experience-lead': 'Responsable expérience client',
    'general-manager': 'Directeur de restaurant',
    'meal-break-unpaid': 'Pause repas (non payée)',
    'meal-break-paid': 'Pause repas (payée)',
    'rest-break-paid': 'Pause (payée)',
    'lactation-break-unpaid': 'Pause allaitement (non payée)',
    'lactation-break-paid': 'Pause allaitement (payée)',
    name: 'Nom',
    'shift-start': 'Début de poste',
    'shift-end': 'Fin de poste',

    // Employee Roster & Time Punches reports
    'employee-roster': 'Liste du personnel',
    'time-punches': 'Pointages',
    'employee-punches': 'Pointages des employés',
    'date-s': 'Date(s)',
    'location-type': 'Type de site',
    'employment-status': 'Statut d’emploi',
    employees: 'Employés',
    corporate: 'Filiale',
    franchise: 'Franchise',
    active: 'Actif',
    terminated: 'Sorti des effectifs',
  },
  'fr-ca': {
    // Legacy camelCase keys
    overtime: 'Temps supplémentaire',
    schedule: 'Horaire',
    punch: 'Poinçon',
    timeAndAttendance: 'Temps et présences',
    timeAndAttendanceAnalysis: 'Analyse des temps et présences',
    crewSwing: 'Équipiers / polyvalents',
    laborSchedule: 'Horaire de main-d’œuvre',

    // All Hours
    'by-date': 'Par date',
    'sum-all-dates': 'Cumuler toutes les dates',
    'all-hours': 'Toutes les heures',
    'fixed-sch-hrs': 'H. fixes à l’horaire',
    'scheduled-hours-for-schedule-symbols':
      'Heures à l’horaire pour les symboles d’horaire « fixes » (indépendants du volume de ventes)',
    'total-need-hrs': 'Total h. requises',
    'total-needed-hours':
      'Total des heures requises - Heures variables requises plus heures de plancher requises + heures fixes à l’horaire',
    'act-gc-vs-proj': 'GC réel c. prévu',
    'actual-gc-minus-gc':
      'GC réel moins le GC prévu dans le logiciel d’établissement des horaires',
    'act-hrs': 'H. réelles',
    'actual-hours-used':
      'Heures réellement utilisées - Heures poinçonnées plus heures salariées à l’horaire',
    'act-hrs-vs-need': 'H. réelles c. requises',
    'actual-hours-used-compared-to-hours-needed':
      'Heures réellement utilisées comparées aux heures requises (Heures requises = Variables requises + H. fixes à l’horaire + H. plancher requises)',
    'indicates-that-actual-hours-are-greater':
      'indique que les heures réelles dépassent les heures requises de 0,5 heure ou plus',
    'indicates-that-actual-hours-are-less':
      'indique que les heures réelles sont inférieures aux heures requises de 0,5 heure ou plus',
    'act-hrs-vs-sch': 'H. réelles c. horaire',
    'actual-hours-used-compared-to-hours-that-were-scheduled':
      'Heures réellement utilisées comparées aux heures inscrites à l’horaire',
    'indicates-that-actual-hours-are-greater-than-scheduled-hours':
      'indique que les heures réelles dépassent les heures à l’horaire de 0,5 heure ou plus',
    'indicates-that-actual-hours-are-less-than-scheduled-hours':
      'indique que les heures réelles sont inférieures aux heures à l’horaire de 0,5 heure ou plus',
    'act-punch-hrs': 'H. poinçonnées réelles',
    'actual-hours-punched-on-the-time-clock':
      'Heures réellement poinçonnées sur l’horodateur',
    'actual-gc': 'GC réel',
    'actual-gc-recorded-by-the-pos': 'GC réel enregistré par le PDV',
    'flr-need-hrs': 'H. plancher requises',
    'manager-hours-needed-to-run-the-floor':
      'Heures de gérant requises pour diriger le plancher',
    'flr-sch-hrs': 'H. plancher à l’horaire',
    'manager-hours-scheduled-to-run-the-floor':
      'Heures de gérant inscrites à l’horaire pour diriger le plancher',
    'projected-gc': 'GC prévu',
    'salaried-manager-hrs': 'H. gérants salariés',
    'since-salaried-managers-do-not-punch-the-clock':
      'Comme les gérants salariés ne poinçonnent pas, ce sont les heures de gérants salariés inscrites à l’horaire qui sont utilisées (on présume que toutes les heures salariées à l’horaire sont travaillées)',
    'sch-hrs': 'H. à l’horaire',
    'scheduled-hours': 'Heures à l’horaire',
    'sched-vs-guide': 'Horaire c. guide',
    'scheduled-hours-compared-to-projected-need':
      'Heures à l’horaire comparées au besoin prévu',
    'indicates-that-scheduled-hours-are-greater-than-projected-need-by-0-5-hours-or-more':
      'indique que les heures à l’horaire dépassent le besoin prévu de 0,5 heure ou plus',
    'indicates-that-scheduled-hours-are-less-than-projected-need-by-0-5-hours-or-more':
      'indique que les heures à l’horaire sont inférieures au besoin prévu de 0,5 heure ou plus',
    'proj-eff': 'Efficacité prévue',
    'was-the-number-of-hours-where-actual-gc':
      'Nombre d’heures où le GC réel se situait à moins de 10 du GC prévu, divisé par le nombre total d’heures d’ouverture du restaurant (Oui/Non)',
    'vlh-sched-hrs': 'H. VLH à l’horaire',
    'sum-of-all-scheduled-variable-labor-hours':
      'Somme de toutes les heures de main-d’œuvre variable inscrites à l’horaire',
    'end-time': 'Heure de fin',

    // Fixed Hours vs Guide
    'fixed-hours-schedule-vs-guide': 'Heures fixes : horaire c. guide',
    'fixed-guide': 'Guide des heures fixes',
    'hours-in-the-fixed-hours-guide':
      'Heures inscrites au guide des heures fixes (aussi appelé contrat) pour un symbole d’horaire donné',
    'sched-vs-contract': 'Horaire c. contrat',
    'sched-time-minus-fixed-guide': 'Temps à l’horaire moins guide des heures fixes',
    'sched-time': 'Temps à l’horaire',
    'hours-scheduled-for-a-given-fixed-symbol':
      'Heures inscrites à l’horaire pour un symbole fixe donné',
    'symbol-description': 'Description du symbole',
    'extended-description-of-labor-scheduling-symbols':
      'Description détaillée des symboles d’établissement des horaires',
    symbol: 'Symbole',
    'one-or-two-letter-scheduling-symbols':
      'Symboles d’horaire à une ou deux lettres',

    // Labor Analysis Summary
    'labor-schedule': 'Horaire de main-d’œuvre',
    'schedule-type': 'Type d’horaire',
    description: 'Description',
    'analysis-summary': 'Sommaire de l’analyse',
    'symbol-over-unders': 'Écarts par symbole',
    'planned-hours': 'Heures planifiées',
    hours: '+/- heures',
    'symbol-over-under-chart': 'Graphique des écarts par symbole',

    // Labor Schedules
    'labor-schedules': 'Horaires de main-d’œuvre',
    'labor-schedules-stats': 'Statistiques des horaires',
    hour: 'Heure',

    // Labor Analysis
    'labor-analysis': 'Analyse de la main-d’œuvre',
    'fixed-sched-flr-need': 'Fixe à l’horaire + plancher requis',
    'fixed-sched-flr-sched': 'Fixe à l’horaire + plancher à l’horaire',
    'fixed-contract-flr-needed': 'Contrat fixe + plancher requis',

    // Labor Statistics
    'labor-statistics': 'Statistiques de main-d’œuvre',
    'we-have-adjusted-this-report':
      'Nous avons ajusté ce rapport afin qu’il corresponde à votre production de rapports DAR.',
    'fields-that-are-not-available':
      'Les champs non disponibles au niveau du quart d’heure ont été retirés par souci de clarté des données.',
    'you-will-still-be-able': 'Vous pourrez toujours les consulter dans le',
    'labor-analysis-report': 'rapport d’analyse de la main-d’œuvre',
    labor: 'Main-d’œuvre',
    sales: 'Ventes',
    projected: 'Prévu',
    'labor-statistics-analysis': 'Analyse des statistiques de main-d’œuvre',

    // Schedule Variance
    'schedule-variance': 'Écart d’horaire',
    'location-summary': 'Sommaire par emplacement',
    'location-detail': 'Détail par emplacement',

    // VLH Over/Under
    'vlh-over-under': 'Écart VLH',
    'projected-orders': 'Commandes prévues',
    'projected-labor': 'Main-d’œuvre prévue',
    'over-under': 'Écart',
    // laborSchedulesChart
    chart: 'Graphique',
    'sort-by-shift-start': 'Trier par début de quart',
    'sort-by-shift-type': 'Trier par type de quart',
    'chart-legend': 'Légende du graphique',
    color: 'Couleur',
    close: 'Fermer',
    floor: 'Plancher',
    'floor-guest-services': 'Plancher - service à la clientèle',
    'floor-production': 'Plancher - production',
    'beverage-specialist': 'Spécialiste des breuvages',
    'grill-regular-menu': 'Grill - menu régulier',
    'grill-breakfast-menu': 'Grill - menu déjeuner',
    'french-fry': 'Frites',
    hashbrown: 'Pomme de terre rissolée',
    window: 'Guichet',
    'administration/cash': 'Administration / caisse',
    'birthday-parties': 'Fêtes d’anniversaire',
    closing: 'Fermeture',
    'food-safety': 'Salubrité alimentaire',
    hiring: 'Embauche',
    'individual-development': 'Développement individuel',
    lobby: 'Salle à manger',
    maintenance: 'Entretien',
    'manager-meeting': 'Réunion des gérants',
    opening: 'Ouverture',
    'planned-maintenance': 'Entretien planifié',
    'pre-shift': 'Avant-quart',
    schedules: 'Horaires',
    stat: 'Statistiques',
    'support/prep': 'Soutien / préparation',
    training: 'Formation',
    transition: 'Transition',
    'truck-delivery': 'Livraison par camion',
    vat: 'Cuve à friture',
    'walk-thru': 'Tournée du restaurant',
    'operations-technology-person': 'OTP (responsable de la technologie des opérations)',
    'guest-experience-lead': 'Responsable de l’expérience client',
    'general-manager': 'Directeur général',
    'meal-break-unpaid': 'Pause repas (non payée)',
    'meal-break-paid': 'Pause repas (payée)',
    'rest-break-paid': 'Pause (payée)',
    'lactation-break-unpaid': 'Pause d’allaitement (non payée)',
    'lactation-break-paid': 'Pause d’allaitement (payée)',
    name: 'Nom',
    'shift-start': 'Début du quart',
    'shift-end': 'Fin du quart',

    // Employee Roster & Time Punches reports
    'employee-roster': 'Liste des employés',
    'time-punches': 'Poinçons',
    'employee-punches': 'Poinçons des employés',
    'date-s': 'Date(s)',
    'location-type': 'Type d’emplacement',
    'employment-status': 'Statut d’emploi',
    employees: 'Employés',
    corporate: 'Société',
    franchise: 'Franchise',
    active: 'Actif',
    terminated: 'Cessation d’emploi',
  },
};
